// src/pages/shrines/ShrineOfTwoSonsMuslimIbnAqeel.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ShrineOfTwoSonsMuslimIbnAqeel = () => {
  const twoSonsShrine =
    "https://ziyaratguide.com/wp-content/uploads/2025/08/The-Two-Sons-of-Muslim-Ibn-Aqeel-Shrine.jpg";

  return (
    <>
      <Helmet>
        <title>Shrine of the Two Sons of Muslim Ibn Aqeel (AS) | Karbala</title>
        <meta
          name="description"
          content="Learn about the shrine of Muhammad and Ibrahim, the young sons of Muslim Ibn Aqeel (AS), who were martyred near Karbala. Discover their story and spiritual significance."
        />
        <meta
          property="og:title"
          content="Shrine of the Two Sons of Muslim Ibn Aqeel (AS) | Karbala"
        />
        <meta
          property="og:description"
          content="Discover the history of the shrine dedicated to the two sons of Muslim Ibn Aqeel (AS) — a site of remembrance and devotion near Karbala."
        />
        <meta property="og:image" content={twoSonsShrine} />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="imam-page">
        {/* Main Content */}
        <div className="imam-content">
          <h1 className="page-title">Shrine of the Two Sons of Muslim Ibn Aqeel</h1>

          <section className="content-section">
            <p>
              The shrine is dedicated to Muhammad and Ibrahim, the two sons of Muslim Ibn Aqeel, 
              who played a crucial role in the events leading up to the Battle of Karbala.
            </p>
            <img
              src={twoSonsShrine}
              alt="Shrine of the Two Sons of Muslim Ibn Aqeel"
              className="imam-image"
            />
          </section>

          <section className="content-section">
            <h2>Historical Background</h2>
            <p>
              Muslim Ibn Aqeel, a cousin of Imam Hussain (PBUH), was sent to Kufa as his emissary 
              but was betrayed and martyred. His sons, Muhammad and Ibrahim, were captured and 
              later martyred as well, symbolising the immense sacrifices made by Imam Hussain’s family.
            </p>
            <p>
              After Muslim Ibn Aqeel's martyrdom, his sons were imprisoned in Kufa. Despite their 
              young age, they were subjected to harsh conditions. They managed to escape but were 
              tragically martyred near the Euphrates River in Musayyib, located approximately 35 
              kilometers from Karbala.
            </p>
          </section>

          <section className="content-section">
            <h2>Visiting the Shrine</h2>
            <p>
              The shrine of Muhammad and Ibrahim is located in Musayyib, a city situated 35 kilometers 
              away from Karbala. It serves as a place of reflection and remembrance for the sacrifices 
              made by these young martyrs. Pilgrims visiting the shrine often express their sorrow and 
              seek blessings, reflecting on the immense courage and devotion exhibited by Muhammad and Ibrahim.
            </p>
          </section>
        </div>

        {/* Sidebar */}
        <aside className="imam-sidebar">
          <h2>Other Shrines</h2>
          <ul>
            <li>
              <Link to="/shrines/shrine-of-imam-hussain">
                Imam Hussain (PBUH) Shrine
              </Link>
            </li>
            <li>
              <Link to="/shrines/al-abbas-shrine">Al Abbas (PBUH) Shrine</Link>
            </li>
            <li>
              <Link to="/shrines/al-mukhayam-shrine">Al-Mukhayam Shrine</Link>
            </li>
            <li>
              <Link to="/shrines/shrine-of-two-sons-muslim-ibn-aqeel">
                Sons of Muslim ibn Aqeel
              </Link>
            </li>
          </ul>
        </aside>
      </div>
    </>
  );
};

export default ShrineOfTwoSonsMuslimIbnAqeel;
